
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1mabk_gr5m5_145",
  "radio": "awsui_radio_1mabk_gr5m5_178",
  "radio--has-description": "awsui_radio--has-description_1mabk_gr5m5_186",
  "radio-control": "awsui_radio-control_1mabk_gr5m5_190",
  "outline": "awsui_outline_1mabk_gr5m5_198",
  "styled-circle-border": "awsui_styled-circle-border_1mabk_gr5m5_220",
  "styled-circle-disabled": "awsui_styled-circle-disabled_1mabk_gr5m5_224",
  "styled-circle-readonly": "awsui_styled-circle-readonly_1mabk_gr5m5_224",
  "styled-circle-fill": "awsui_styled-circle-fill_1mabk_gr5m5_229",
  "styled-circle-checked": "awsui_styled-circle-checked_1mabk_gr5m5_245"
};
  